import React, { memo, useState } from "react";
import { Link } from "react-router-dom";
import brand from "../../assets/Images/maersk.svg";
import GlobalSearch from "../GlobalSearch/GlobalSearch";

import "./Navbar.css";
import {
  Icon,
  Typography,
} from "@anchor/react-components/dist/lib/components";

import { UseNavBar } from ".";
import NavLinkWithIcon from "../NavLinkWithIcon/NavLinkWithIcon";
import { McIcon, McInput } from "@maersk-global/mds-react-wrapper";


function Navbar() {
  const [isSearchOpen, setIsSearchOpen] = useState(false);

  const {
    location,
    handleTour,
    graphData,
    incidentSearchValue,
    incidentSearchResults,
    isSearchingIncident,
    isSuggestingIncident,
    showIncidentResults,
    handleIncidentSearchChange,
    handleIncidentSearchSubmit,
    handleSelectIncidentResult,
    closeIncidentResults,
  } = UseNavBar();

  const handleSearchOpen = () => {
    setIsSearchOpen(true);
  };

  const handleSearchClose = () => {
    setIsSearchOpen(false);
  };

  const handleIncidentSearchInput = (e) => {
    handleIncidentSearchChange(e.target.value);
  };

  const handleIncidentSearchKeyDown = (e) => {
    if (e.key === "Enter") {
      handleIncidentSearchSubmit(e.target.value);
    }
  };

  return (
    <>
      <div className="custom-navbar">
        <Link className="brand" to="/">
          {" "}
          <img alt="maersk-logo" style={{ width: "160px", height: "64px" }} src={brand} />
        </Link>
        <div className="divider"></div>
        <div className="title-container">
          <span className="postmortem-title">POST-MORTEM</span>
        </div>

        {/* Search Icon Trigger */}
        {/* <div className="search-icon-container" onClick={handleSearchOpen}>
          <div className="search-icon-button">
            <Icon size="24" name="magnifying-glass" />
          </div>
          <div className="search-icon-text">
            <Typography className="search-text" paragraph>

              <span style={{ fontSize: "17px" }}>Search</span>
            </Typography>
          </div>
        </div> */}

        {location.pathname === "/ongoing-postmortems" ||
          location.pathname === "/create" ||
          location.pathname === "/report" ||
          location.pathname === "/archived-postmortems" ||
          location.pathname === "/download-report" ||
          location.pathname === "/insights-dashboard" ||
          location.pathname === "/editpostmortem" ? (
          <></>
        ) : (
          <div className="tour-button-container" onClick={() => handleTour()}>
            <div style={{ paddingTop: "2px" }}>
              <Icon size="24" name="eye" />
            </div>
            <div className="take-tour-container">
              <Typography className="take-tour-text" paragraph>
                <span style={{ fontSize: "17px" }}>Take Tour</span>
              </Typography>
            </div>
          </div>
        )}

        <div style={{ marginLeft: "auto" }}></div>

        {/* Incident ID Search (searches both ongoing and archived postmortems) */}
        {(
          <div className="incident-search-container">
            <McInput
              className="incident-search-input"
              label=""
              placeholder="Search Incident ID"
              fit="small"
              value={incidentSearchValue}
              disabled={isSearchingIncident}
              onInput={handleIncidentSearchInput}
              onKeyDown={handleIncidentSearchKeyDown}
            >
              <McIcon slot="before" icon="magnifying-glass" size="16"></McIcon>
            </McInput>

            {showIncidentResults && (
              <div className="incident-search-results">
                {isSearchingIncident || (isSuggestingIncident && incidentSearchResults.length === 0) ? (
                  <div className="incident-search-result-item incident-search-status">
                    Searching...
                  </div>
                ) : incidentSearchResults.length === 0 ? (
                  <div className="incident-search-result-item incident-search-status">
                    No postmortem found for "{incidentSearchValue}"
                  </div>
                ) : (
                  incidentSearchResults.map((result, idx) => (
                    <div
                      key={`${result._source}-${result.customID || result.incidentID || idx}`}
                      className="incident-search-result-item"
                      onClick={() => handleSelectIncidentResult(result)}
                    >
                      <span className="incident-search-result-id">
                        {result.incidentID || result.customID}
                      </span>
                      <span
                        className={`incident-search-result-badge incident-search-result-badge--${result._source}`}
                      >
                        {result._source === "archived" ? "Archived" : "Ongoing"}
                      </span>
                    </div>
                  ))
                )}
              </div>
            )}
          </div>
        )}

        <div className="profile-and-select-input-container first-step">
          <a
            href={process.env.REACT_APP_POSTMORTEM_SUPPORT_TEAMS_CHANNEL}
            target="_blank"
            rel="noreferrer"
            title="Support"
            style={{ display: "flex", alignItems: "center", color: "black", marginRight: "12px", textDecoration: "none" }}
          >
            <McIcon icon="headset" size="24" />
          </a>
          <div className="profile-container-wrapper">
            <div className="profile-container">
              {typeof graphData?.name === "string"
                ? graphData.name[0] + graphData.name[1].toUpperCase()
                : ""}
            </div>
          </div>
        </div>
      </div>

      {/* Global Search Modal Overlay */}
      <GlobalSearch
        isOpen={isSearchOpen}
        onClose={handleSearchClose}
      />
    </>
  );
}
Navbar.whyDidYouRender = true;

export default memo(Navbar);





